<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật khóa học: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="24">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-row :gutter="20" style="min-height: 400px">
              <el-col :span="12">
                <el-form-item prop="image" label="Ảnh khóa học">
                  <el-upload
                    class="course-uploader"
                    :action="upload.url"
                    :headers="upload.headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :on-progress="handleAvatarProcess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="modelData.image_path" :src="modelData.image_path" class="course">
                    <i v-else class="el-icon-plus course-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">
                      <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                      Ảnh khóa học có dung lượng tối đa tải lên là 2Mb
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item prop="type" label="Loại khóa học" class="form-item">
                      <el-select disabled v-model="modelData.type" filterable  placeholder="Loại khóa học" class="input-select">
                        <el-option
                          v-for="item in lists.listTypeCourse"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="modelData.type == 1" prop="code" label="Mã môn học" class="form-item">
                      <el-input disabled v-model="modelData.code" class="input-seach"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
<!--                     <el-form-item v-if="modelData.type == 1" prop="level_id" label="Chọn phân hệ" class="form-item">
                      <el-select disabled v-model="modelData.level_id" filterable placeholder="" class="input-select">
                        <el-option
                          v-for="item in lists.listLevel"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="modelData.type == 1" prop="facult_id" label="Chọn chuyên ngành" class="form-item">
                      <el-select v-model="modelData.facult_id" filterable placeholder="" class="input-select">
                        <el-option
                          v-for="item in lists.listFacult"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên khóa học" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
                </el-form-item>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item v-if="modelData.type == 0" prop="category_course_id" label="Lĩnh vực khóa học" class="form-item">
                      <el-select v-model="modelData.category_course_id" filterable placeholder="Lĩnh vực khóa học" class="input-select">
                        <el-option
                          v-for="item in lists.listCategoryCourse"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item v-if="accountInfo.user_type != 2" prop="teacher_id" label="Giảng viên" class="form-item">
                      <el-select v-model="modelData.teacher_id" filterable placeholder="Giảng viên" class="input-select">
                        <el-option
                          v-for="item in lists.listTeacher"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item prop="video_youtube" label="Link video Youtube" class="form-item">
                  <el-input v-model="modelData.video_youtube" :rows="5" type="textarea" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item prop="price" label="Giá" class="form-item">
                      <el-input type="age" v-model.number="modelData.price" class="input-seach" auto-complete="off">
                        <template slot="append">{{ modelData.price | vnd }}</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="level" label="Cấp độ" class="form-item">
                      <el-select v-model="modelData.level" filterable  placeholder="Cấp độ" class="input-select">
                        <el-option
                          v-for="item in lists.listRank"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="price_brick" label="Giá gạch" class="form-item">
                      <el-input type="age" v-model.number="modelData.price_brick" class="input-seach" auto-complete="off">
                        <template slot="append">{{ modelData.price_brick | vnd }}</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="total_time_videos_txt" label="Tổng thời gian" class="form-item">
                      <el-input v-model="modelData.total_time_videos_txt" class="input-seach" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item prop="slug" label="SEO Link" class="form-item">
                  <el-input v-model="modelData.slug" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="20">
<!--                 <el-form-item prop="description" label="Mô tả khóa học">
                  <tinymce
                    id="d2"
                    v-model="modelData.description"
                    :toolbar1="tinymce.toolbar1"
                    :other_options="{ height: '300px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
                </el-form-item> -->
                <el-form-item prop="content" label="Nội dung khóa học" v-if="canUpdate">
                  <tinymce
                    id="d1"
                    v-model="modelData.content"
                    :toolbar1="tinymce.toolbar1"
                    :other_options="{ height: '500px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'CourseUpdate',
  metaInfo () {
    return {
      title: 'Khóa học'
    }
  },
  components: {
    tinymce
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      canSubmit: true,
      loadingDone: false,
      canUpdate: false,
      modelData: {
        level_id: '',
        facult_id: '',
        specialized_id: '',
        name: '',
        type: 0,
        category_course_id: '',
        university_id: '',
        teacher_id: '',
        image: '',
        video_youtube: '',
        image_path: '',
        price: '',
        price_brick: '',
        content: '',
        sale: '',
        date_start: '',
        date_end: '',
        date_use: '',
        total_time_videos_txt: '',
        status: true
      },
      lists: {
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ],
        listUniversity: [
          {key: 0, value: 'Không thuộc trường nào'},
          {key: 1, value: 'Trường Học Viện Ngân Hàng'},
          {key: 2, value: 'Trường Kinh Tế Quốc Dân'}
        ],
        listRank: [
          {key: 0, value: 'Chưa xếp hạng'},
          {key: 1, value: 'Người mới học'},
          {key: 2, value: 'Trung bình'},
          {key: 3, value: 'Nâng cao'}
        ],
        listTypeCourse: [
          {key: 0, value: 'Khóa học kĩ năng'},
          {key: 1, value: 'Khóa học đào tạo'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: []
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'courses/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên khóa học' },
          { min: 2, max: 191, message: 'Tên khóa học có chiều dài từ 2 tới 191 kí tự' }
        ],
        price: [
          { required: true, message: 'Vui lòng nhập giá khóa học' },
          { type: 'number', message: 'Giá khóa học phải là kiểu số' }
        ],
        price_brick: [
          { required: true, message: 'Vui lòng nhập giá khóa học bị gạch' },
          { type: 'number', message: 'Giá khóa học bị gạch phải là kiểu số' }
        ],
        category_course_id: [
          { required: true, message: 'Vui lòng nhập lĩnh vực khóa học' }
        ],
        teacher_id: [
          { required: true, message: 'Vui lòng nhập giảng viên của khóa học' }
        ],
        image: [
          // { required: true, message: 'Vui lòng upload ảnh của khóa học' }
        ],
        date_use: [
          { required: true, message: 'Vui lòng nhập số ngày sử dụng của khóa học' },
          { type: 'number', message: 'Số ngày sử dụng của khóa học phải là kiểu số' }
        ],
        slug: [
          { required: true, message: 'Vui lòng nhập Seo link' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    // this.fetchModel()
    this.configUpload()
    this.fetchListCategoryCourse()

    if (this.accountInfo.user_type === 1) {
      this.fetchListTeacher()
    }

    setTimeout(() => {
      this.canUpdate = true
    }, 500)
    setTimeout(() => {
      this.fetchModel()
    }, 1000)
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      // let formData = new FormData()
      // formData.append('file', file.blob())
      // let response = await axios.post('courses/upload', formData)
      // if (response.code === 1) {
      //   success(response.data.path)
      // } else {
      //   return false
      // }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-update', text: 'Cập nhật' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'courses-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            setTimeout(() => {
              this.loadingDone = true
            }, 2000)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực khóa học
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1, 'type': 0, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      let data = {
        'status': 1,
        'limit': -1,
        'user_type': 2
      }
      axios.get('users', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về trường đại học
    fetchListUniversitiy () {
      axios.get('universities', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listUniversity = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'level_id': this.modelData.level_id
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.modelData.school_id,
        'level_id': this.modelData.level_id,
        'facult_id': this.modelData.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('courses/' + this.$route.params.course_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật khóa học thành công',
              type: 'success',
              duration: '1000'
            })
            // this.$router.push({name: 'courses-index'})
            // this.$router.push({name: 'courses-show', params: {course_id: this.$route.params.course_id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh khóa học có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/courses/Update.vue